export default {
  beforeRouteLeave(to, from, next) {
    console.log(from)
    this.$store.dispatch('tagsView/setCurrentView', from)
    next()
  },
  watch: {
    '$store.state.tagsView.cachedViews': {
      handler(data) {
        // 监听缓存列表的变化，如果缓存列表中没有当前的路由或组件则在缓存中销毁该实例
        const name = this.$route.name
        if (this.$store.state.tagsView.currentView.name === name && !data.includes(name)) {
          this.$destroy()
        }
      }
    },
  },
  activated() {
    if (this.dataTableSearch && this._url) {
      this.dataTableSearch()
    }
  }
}
